{
    "name": "menu-web",
    "description": "The extended RIO Application Menu",
    "private": true,
    "version": "0.1.0",
    "scripts": {
        "start": "vite",
        "build": "vite build",
        "preview": "vite preview",
        "test": "vitest run",
        "test:ci": "vitest run --reporter=junit --outputFile.junit=./results/junit.xml",
        "test-dev": "vitest",
        "coverage": "vitest run --coverage",
        "lint": "biome check .",
        "lint-fix": "npm run lint -- --write",
        "lint-fix-unsafe": "npm run lint-fix -- --unsafe",
        "format-code": "biome format --write .",
        "audit": "npm audit --registry https://registry.npmjs.org --parseable --omit=dev",
        "pull-translations": "phrase pull --access_token $PHRASEAPP_ACCESS_TOKEN && npm run merge-translations",
        "merge-translations": "node ./mergeTranslations.js && rm -rf src/features/translations/temp",
        "postinstall": "if [ \"$CI\" != \"true\" ]; then pre-commit install; fi"
    },
    "dependencies": {
        "@intercom/messenger-js-sdk": "0.0.20",
        "@redux-devtools/extension": "4.0.0",
        "@reduxjs/toolkit": "2.12.0",
        "@rio-cloud/rio-uikit": "2.5.1",
        "@sentry/browser": "10.70.0",
        "classnames": "2.5.1",
        "configcat-react": "5.1.0",
        "es-toolkit": "1.50.0",
        "events": "3.3.0",
        "iframe-resizer-react": "1.1.0",
        "oidc-client-ts": "3.5.0",
        "qs": "6.15.3",
        "react": "19.2.8",
        "react-dom": "19.2.8",
        "react-hook-form": "7.85.0",
        "react-intl": "10.1.20",
        "react-redux": "9.3.0",
        "react-router": "8.3.0"
    },
    "devDependencies": {
        "@biomejs/biome": "2.5.7",
        "@rio-cloud/biome-config": "2.0.0",
        "@sentry/core": "10.70.0",
        "@testing-library/dom": "10.4.1",
        "@testing-library/jest-dom": "7.0.1",
        "@testing-library/react": "16.3.2",
        "@testing-library/user-event": "14.6.3",
        "@types/jest": "30.0.0",
        "@types/node": "25.3.5",
        "@types/qs": "6.15.1",
        "@types/react": "19.2.18",
        "@types/react-dom": "19.2.4",
        "@vitejs/plugin-react": "6.0.5",
        "happy-dom": "20.11.2",
        "jsdom": "30.0.1",
        "license-checker": "25.0.1",
        "msw": "2.15.0",
        "nodenv": "0.1.0",
        "rollup-plugin-visualizer": "6.0.11",
        "typescript": "5.9.3",
        "vite": "8.2.1",
        "vitest": "4.1.10"
    },
    "browserslist": [
        "last 2 versions",
        "last 5 Chrome versions",
        "Firefox >= 90",
        "Edge >= 95",
        "Safari >= 14"
    ],
    "msw": {
        "workerDirectory": ""
    },
    "overrides": {},
    "engines": {
        "node": ">=24.x",
        "npm": ">=11"
    }
}
